/* eslint-disable react/jsx-no-bind */
import { useState } from 'react'
import styled from '@emotion/styled'
import { Form, Modal } from 'util/ui'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import { Icon } from 'shared/ui'
import ValidatedField from 'shared/components/ui/ValidatedField'
import sharedStyles from '../styles.less'

const EmailModal = styled(Modal)`
  width: 445px !important;
  & .content {
    background: transparent !important;
  }
`

const CloseIcon = styled(Icon)`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
`

const EmailForm = ({
  formFields,
  onChange,
  canSave,
  submitForm,
  saving,
  formFieldsErrors,
  resetForm,
  onClose,
  onSubmit,
}) => {
  const [focusedField, setFocusedField] = useState(null)
  const [emailFormVisible, setEmailFormVisibility] = useState(false)

  return (
    <EmailModal
      open={emailFormVisible}
      closeIcon={
        <CloseIcon
          name="close"
          onClick={() => {
            setEmailFormVisibility(false)
            if (onClose) {
              onClose()
            }
          }}
        />
      }
      trigger={
        <a onClick={() => setEmailFormVisibility(true)}>Wrong email address?</a>
      }
    >
      <Modal.Content>
        <Form size="large" className={sharedStyles.form}>
          <Form.Field>
            <label htmlFor="email">Email Address</label>
            <ValidatedField
              placeholder="someone@gmail.com"
              name="email"
              type="email"
              value={formFields.email}
              errorMessage={focusedField !== 'email' && formFieldsErrors.email}
              onChange={(_, { value }) => {
                onChange('email', value, null, { validate: true })
              }}
              onFocus={() => {
                setFocusedField('email')
              }}
              onBlur={() => {
                setFocusedField(null)
              }}
              fieldRefCallback={disableLastPassInputRef}
              autoFocus
            />
          </Form.Field>
          <Form.Button
            primary
            size="big"
            fluid
            disabled={!canSave}
            onClick={() => {
              submitForm().then(() => {
                setEmailFormVisibility(false)
                resetForm()
                onSubmit()
              })
            }}
          >
            {!saving ? 'Resend code' : 'Resending code...'}
          </Form.Button>
        </Form>
      </Modal.Content>
    </EmailModal>
  )
}

export default EmailForm
